import translations from "./translations";
import { TRANSLATE_ENABLED } from "./config";
import { getLogger } from "./logging";

const log = getLogger("Internationalization");

function inverse(obj) {
  var retobj = {};
  for (var key in obj) {
    retobj[obj[key]] = key;
  }
  return retobj;
}

export const local = navigator.language || navigator.userLanguage || "";

export const language = local.split("-")[0];
const enInv = inverse(translations.en);

export function translate(str) {
  if (!TRANSLATE_ENABLED || !translations[language]) return str;
  const translation = translations[language][enInv[str]];
  if (!translation) {
    str && log.warn(`No ${language}-translation found for ${str}`);
    return str;
  }
  return translation;
}
